var map = {
	"./modern-1.jpg": 65357,
	"./modern-10.jpg": 50645,
	"./modern-11.jpg": 78048,
	"./modern-2.jpg": 73048,
	"./modern-3.jpg": 51046,
	"./modern-4.jpg": 20093,
	"./modern-5.jpg": 65700,
	"./modern-6.jpg": 46306,
	"./modern-7.jpg": 87798,
	"./modern-8.jpg": 14691,
	"./modern-9.jpg": 75329
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 343;